import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Result, Button } from 'antd';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

// Stops the entire SPA from blanking on a render error. Errors thrown inside
// route components surface here with a "Reload" CTA; the page footer prints
// the stack so PMs can paste it into Lark/Slack when reporting.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('[admin] uncaught render error', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <Result
          status="error"
          title="页面渲染异常"
          subTitle={this.state.error.message}
          extra={[
            <Button
              type="primary"
              key="reload"
              onClick={() => window.location.reload()}
            >
              刷新页面
            </Button>,
          ]}
        />
      );
    }
    return this.props.children;
  }
}
